import React from "react";
import { useSubscription } from "@apollo/client";
import { ON_BALANCE_UPDATE } from "../../../../graphql/graphql_banking/legder/subscription";
import {
  OnBalanceUpdate,
  OnBalanceUpdateVariables,
} from "../../../../graphql/graphql_banking/legder/types/OnBalanceUpdate";
import { bankingClient } from "../../../../apolloClient";
import { _myInformation } from "../../../../indexDB/data";
import { useAppDispatch, useAppSelector } from "../../../../redux/hook";
import { useCreateOrUpdateAccountCache } from "../../../NewAccount/tools";
import { setMyAccount } from "../../../../redux/ledger/ledgerSlice";

const LedgerSub = (props: { clientId: number | null }) => {
  const { clientId: clientIdProps } = props;
  const dispatch = useAppDispatch();
  const { clientId, paynovateId } = useAppSelector(
    (state) => state.ledger.myAccount,
  );
  const { updateOrCreate } = useCreateOrUpdateAccountCache();

  useSubscription<OnBalanceUpdate, OnBalanceUpdateVariables>(
    ON_BALANCE_UPDATE,
    {
      variables: {
        clientId: clientIdProps ?? clientId,
      },
      client: bankingClient,
      onSubscriptionData: ({ subscriptionData: { data } }) => {
        if (data?.onBalanceUpdate) {
          if (
            paynovateId &&
            paynovateId === data?.onBalanceUpdate?.paynovateId
          ) {
            dispatch(setMyAccount(data.onBalanceUpdate));
          }
          updateOrCreate(data?.onBalanceUpdate);
        }
      },
    },
  );

  return <></>;
};

export default LedgerSub;
